import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';

const WebAds = () => {
    const intl = useIntl();
    const [showWebNotify, setShowWebNotify] = useState(false);
    const getRandomMsg = () => (Math.random() < 0.5 ? 1 : 2);
    const [showMsg, setShowMsg] = useState(() => getRandomMsg());

    useEffect(() => {
        setTimeout(() => {
            setShowMsg(getRandomMsg());
            setShowWebNotify(true)
            setTimeout(() => setShowWebNotify(false), 30000)
        }, 2000)
        setTimeout(() => {
            setShowMsg(getRandomMsg());
            setShowWebNotify(true)
            setTimeout(() => setShowWebNotify(false), 30000)
        }, 42000)
    }, []);

    const openSite = (msg) => {
        setShowWebNotify(false)
        if (msg === 1)
            window.open(`https://www.alarm-clock.net/${intl.locale.split("-")[0].toLowerCase()}?utm_source=olstptmr`, '_blank', '');
        if (msg === 2)
            window.open(`https://timenowin.net/${intl.locale.split("-")[0].toLowerCase()}?utm_source=olstptmr`, '_blank', '');
    }

    return (
        <React.Fragment>
            {showWebNotify ?
                <div className="alert alert-warning alert-dismissible fade show marquee" role="alert" onClick={() => openSite(showMsg)}>
                    <p><span className="blink" role="img" aria-label="Explosion">💥💥</span>
                        {showMsg === 1 ?
                        <FormattedMessage id="body.lang.webads" />
                        :
                        <FormattedMessage id="body.lang.webads2" />}
                        <span className="blink" role="img" aria-label="Explosion">💥💥</span></p>
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                : ''}
        </React.Fragment>
    )
}

export default injectIntl(WebAds);